var _rect, _rect2, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgForwardIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 49,
    height: 49,
    rx: 11.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 49,
    height: 49,
    rx: 11.5,
    stroke: "#201F4F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.1599 18.0841C22.7922 17.7197 22.1986 17.7223 21.8341 18.0901C21.4697 18.4578 21.4723 19.0514 21.8401 19.4159L24.0438 21.6C24.9381 22.4864 25.5516 23.0965 25.9668 23.6134C26.37 24.1155 26.5083 24.438 26.5452 24.7269C26.5683 24.9082 26.5683 25.0918 26.5452 25.2731C26.5083 25.562 26.37 25.8845 25.9668 26.3866C25.5516 26.9035 24.9381 27.5136 24.0438 28.4L21.8401 30.5841C21.4723 30.9486 21.4697 31.5422 21.8341 31.9099C22.1986 32.2777 22.7922 32.2803 23.1599 31.9159L25.4034 29.6924C26.2483 28.855 26.9389 28.1705 27.4287 27.5607C27.938 26.9265 28.3066 26.2828 28.4051 25.5102C28.4483 25.1714 28.4483 24.8286 28.4051 24.4898C28.3066 23.7172 27.938 23.0735 27.4287 22.4393C26.9389 21.8295 26.2483 21.1451 25.4034 20.3076L23.1599 18.0841Z",
    fill: "#201F4F"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgForwardIcon);
export default __webpack_public_path__ + "static/media/forward-icon.8009d48497ec946eace7041cf0667b9d.svg";
export { ForwardRef as ReactComponent };